import {
  coreExtensionData,
  createExtension,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';
import { makeStyles } from '@material-ui/core/styles';
import { ReactNode } from 'react';

const useStyles = makeStyles({
  raiz: { display: 'flex', flexDirection: 'column', height: '100vh' },
  contenido: { flex: 1, minHeight: 0, overflow: 'auto', isolation: 'isolate' },
});

const Layout = ({ menu, contenido }: { menu: ReactNode; contenido: ReactNode }) => {
  const classes = useStyles();
  return (
    <div className={classes.raiz}>
      {menu}
      {/* TechDocs fija sus índices laterales al borde de este elemento; sin él
          los sube hasta el tope de la ventana, encima del menú */}
      <div className={`${classes.contenido} techdocs-reader-page`}>{contenido}</div>
    </div>
  );
};

/**
 * Reemplaza app/layout (SidebarPage, con la barra lateral fija) por el menú
 * superior encima del contenido. Mismas entradas que el layout original.
 */
export const layoutSuperior = createExtension({
  name: 'layout',
  attachTo: { id: 'app/root', input: 'children' },
  inputs: {
    nav: createExtensionInput([coreExtensionData.reactElement], { singleton: true }),
    content: createExtensionInput([coreExtensionData.reactElement], { singleton: true }),
  },
  output: [coreExtensionData.reactElement],
  factory: ({ inputs }) => [
    coreExtensionData.reactElement(
      <Layout
        menu={inputs.nav.get(coreExtensionData.reactElement)}
        contenido={inputs.content.get(coreExtensionData.reactElement)}
      />,
    ),
  ],
});
